export const VENUE_UUID = "db869f4f-5ccf-44b8-b6c0-d034431dcfdd"